// 海滨之心 翻倍卡求助
var SeasideStarShareRedirector = xClass("SeasideStarShareRedirector", BaseRedirector)
SeasideStarShareRedirector.prototype.getName = function () {
    var self = this
    return "seasideStarShare"
}
SeasideStarShareRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
SeasideStarShareRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    var um = UserManager.getInstance();
    console.log("[Seaside] SeasideStarShareRedirector um.settings",um.settings)
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }
    console.log("[Seaside] SeasideStarShareRedirector um.uid",um.uid)
    console.log("[Seaside] SeasideStarShareRedirector param",param)


    if (um.uid && param.inviteCode && param.shareId) {
        let http = SeasideStarShareClickHttp.new();
        http.addEventListener(Events.kComplete, () => {
            Toast.make(getText("分享完成,获取翻倍卡！"));
        })
        http.addEventListener(Events.kError, (evt = {}) => {
            // Toast.make(quickGetErrorText(evt.data, "帮助链接已经失效！"));
            if (evt.data){
                Toast.make(getText("error.tip."+evt.data.toString()));
            }
        })
        http.load(param.inviteCode, param.shareId);
    }
    return true
}
module.exports = SeasideStarShareRedirector
